<div class="content dark">
	<div class="row">
		<div class="col-12">
			<div class="item-panel flush">
				<div class="heading">Alert Log for {{asset.asset_name}}</div>
				<div class="content">
					<div *ngIf="alerts === undefined" class="text-center pt-3 pb-3">
						<div class="logo-spin light"></div>
						Loading alerts...
					</div>
					<div *ngIf="alerts && !alerts.length">
						No alerts have been recorded for this asset
					</div>
					<div *ngIf="alerts && alerts.length" class="alert-list">
						<table>
							<thead>
								<tr>
									<th>Date</th>
									<th>Component</th>
									<th>Summary</th>
									<th>Acknowledged</th>
									<th *ngIf="api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master'">
										Delete</th>
								</tr>
							</thead>
							<tbody *ngFor="let alert of alerts">
								<tr>
									<td>{{alert.timestamp | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0) }}</td>
									<td>{{alert.component_name}}</td>
									<td class="truncate" [title]="alert.description"><span>{{alert.description}}</span></td>
									<td>
										<div *ngIf="alert.ack_by" [title]="alert.ack_timestamp | datetime : 'offset' : (fleet ? fleet.time_offset_hours : 0)">
											{{alert.ack_email}}
											<app-action-button *ngIf="this.api.user.role !== 'readonly'" [action]="UnacknowledgeAlert" [args]="[alert.alert_id]" [context]="this" title="Undo acknowledgement" btnClass="btn-icon btn-flush btn-sm" confirm="Undo acknowledgement?"
											processing="..."><i class="icon-minus-circled"></i></app-action-button>
										</div>
										<app-action-button *ngIf="!alert.ack_by" [disabled]="this.api.user.role === 'readonly'" [action]="PromptAcknowledge" [args]="[alert.alert_id]" [context]="this"
											btnClass="btn-success btn-sm" processing="...">Acknowledge</app-action-button>
									</td>
									<td *ngIf="api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master'">
										<app-action-button [action]="DeleteAlert" [args]="[alert.alert_id]" [context]="this" title="Delete alert" btnClass="btn-icon btn-danger btn-sm" confirm="Delete this alert completely?"
											processing="..."><i class="icon-trash"></i></app-action-button>
									</td>
								</tr>
								<tr *ngIf="alert.ack_note">
									<td [attr.colspan]="(api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') ? 5 : 4" class="alert-note">
										{{alert.ack_note}}
									</td>
								</tr>
							</tbody>
						</table>
						<ngb-pagination [collectionSize]="totalAlerts" [pageSize]="alertItemsPerPage" [(page)]="alertCurrentPage" (pageChange)="alertUpdatePage()" [maxSize]="10"
							[directionLinks]="true" [rotate]="true"></ngb-pagination>
						<div class="alert-actions">
							<app-action-button [action]="ExportAlerts" [context]="this" btnClass="btn-info" processing="Exporting...">
								Download Alert Data</app-action-button>
							<app-action-button [action]="AcknowledgeAll" [context]="this" btnClass="btn-danger" processing="Acknowledging..." complete="All alerts acknowledged">
								Acknowledge All</app-action-button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<ng-template #ackNoteModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Acknowledgement notes</h4>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div>Enter a note</div>
		<div class="form-group">
			<input [(ngModel)]="acknowledgingNote" type="text" class="form-control" ngbAutofocus>
		</div>
		<app-action-button [action]="AcknowledgeAlert" [context]="this" btnClass="btn-success btn-sm" processing="...">
			Acknowledge</app-action-button>
	</div>
</ng-template>